import React, { useEffect, useState } from "react";
import { getCoupons, deleteCoupon } from "../../api/couponService";
import { FaEye, FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import Pagination from "../Pagination/Pagination";
import { useNavigate } from "react-router-dom";
import FullPageLoader from "../../common/FullPageLoader";
import EmptyState from "../../common/EmptyState";
export default function CouponList() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);

  const navigate = useNavigate();
  // FIXED DATE FORMAT (DD/MM/YYYY)
  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    const date = new Date(dateStr);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  };
  // LOAD DATA
  const loadData = async () => {
    try {
      setLoading(true);

      const res = await getCoupons(currentPage, itemsPerPage);

      const data = Array.isArray(res?.data) ? res.data : [];
      const pagination = res?.pagination || {};

      setList(data);

      setTotalItems(pagination?.total || data.length || 0);

      setError("");
    } catch (err) {
      setError("Failed to load coupons");
      setList([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadData();
  }, [currentPage]);
  // DELETE
  const handleDelete = async (id) => {
    try {
      if (!window.confirm("Delete this coupon?")) return;
      await deleteCoupon(id);
      const response = await deleteCoupon(id);
      setSuccess("Coupon deleted successfully");
      loadData();
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Failed to delete coupon");
      setTimeout(() => setError(""), 3000);
    }
  };
  if (loading) {
    return <FullPageLoader text="Loading Coupons..." />;
  }
  return (
    <div className="container-fluid p-4 np-coupons-page">
      {success && <div className="alert alert-success">{success}</div>}
      {error && <div className="alert alert-danger">{error}</div>}
      
      {/* TABLE */}
      <div className="card p-3">
        {list.length === 0 ? (
          <EmptyState
            action={
              <button className="btn btn-primary" onClick={() => navigate("/coupon/add")}>
                <FaPlus /> Add Coupon
              </button>
            }
          />
        ) : (
          <>
            <div className="d-flex justify-content-end align-items-center pb-3">
              <button className="btn btn-primary" onClick={() => navigate("/coupon/add")}>
                <FaPlus /> Add Coupon
              </button>
            </div>
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th className="text-dark fw-bold">#</th>
                  <th className="text-dark fw-bold">Title</th>
                  <th className="text-dark fw-bold">Code</th>
                  <th className="text-dark fw-bold">Discount Value</th>
                  <th className="text-dark fw-bold">Min Amount</th>
                  <th className="text-dark fw-bold">Max Amount</th>
                  <th className="text-dark fw-bold">Expiry Date</th>
                  <th className="text-dark fw-bold">Status</th>
                  <th className="text-dark fw-bold">Action</th>
                </tr>
              </thead>
              <tbody>
                {list.map((c, index) => (
                <tr key={c._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{c.title}</td>
                  <td>{c.code}</td>
                  <td>{c.discountValue}</td>
                  <td>₹{c.minOrderAmount}</td>
                  <td>₹{c.maxDiscountAmount}</td>

                  <td>{formatDate(c.expiryDate)}</td>

                  <td>
                    <span className={`badge ${c.status === "ACTIVE" ? "bg-success" : "bg-danger"}`}>
                      {c.status}
                    </span>
                  </td>

                  <td>
                    <div className="d-flex gap-2 np-table-actions">
                      <FaEye
                        className="np-table-action-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/coupon/view/${c.code}`, {
                            state: { couponId: c._id },
                          })
                        }
                      />
                      <FaEdit
                        className="np-table-action-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/coupon/edit/${c.code}`, {
                            state: { couponId: c._id },
                          })
                        }
                      />
                      <FaTrash
                        className="np-table-action-icon"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleDelete(c._id)}
                      />
                    </div>
                  </td>
                </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
      {list.length > 0 && (
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={(page) => setCurrentPage(page)}
        />
      )}
    </div>
  );
}
